import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

const indentLevels = {
  1: '40px',
  2: '60px',
  3: '80px',
  4: '100px',
  5: '120px',
  6: '140px',
};

@Component({
  selector: 'miq-last-group-renderer',
  template: `
    <div>
      <span [ngStyle]="{ left: rowIndent }" class="miq-last-group">{{ value }}</span>
    </div>
  `,
  styles: ['.miq-last-group { text-align: left; position: absolute; }'],
  standalone: false,
})
export class LastGroupRendererComponent implements ICellRendererAngularComp {
  public value: string = undefined;
  public rowIndent: string = undefined;

  refresh(params: ICellRendererParams): boolean {
    this.setValues(params);
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.setValues(params);
  }

  private setValues(params: ICellRendererParams) {
    this.value = params.value;
    const rowGroupIndex = !!params.node ? params.node.rowGroupIndex : null;
    this.rowIndent = indentLevels[rowGroupIndex] != null ? indentLevels[rowGroupIndex] : '0px';
  }
}
